export const ORDER_SUMMARY = "order summary"
export const CALL_SUPPORT_PHONE_NUMBER = "call support phone number"
export const CALL_SUPPORT_NUMBER = "call support number"
export const HELP_SUPPORT = "help support"
export const MY_ACCOUNT_ORDERS = "my account:orders"
export const MY_ACCOUNT = "my account"
